import { camelToTitleCase } from '../utils/camelToTitleCase.js';

const recordTypeLabelTokenOverrides = {
  api: 'API',
  bom: 'BOM',
  rma: 'RMA',
  crm: 'CRM',
  eeoc: 'EEOC',
  sla: 'SLA',
  sku: 'SKU'
};

const buildRecordTypeLabel = (recordTypeKey) => {
  return camelToTitleCase(recordTypeKey)
    .split(' ')
    .map((token) => recordTypeLabelTokenOverrides[token.toLowerCase()] || token)
    .join(' ');
};

export const recordTypeKeys = [
  'accessReview',
  'accessToken',
  'account',
  'accountingPeriod',
  'action',
  'activity',
  'ad',
  'adCampaign',
  'address',
  'adGroup',
  'alert',
  'announcement',
  'apiKey',
  'application',
  'appointment',
  'approval',
  'asset',
  'attachment',
  'attendanceRecord',
  'attendee',
  'attributionEvent',
  'audience',
  'auditLog',
  'backlogItem',
  'balanceSheetReport',
  'bankAccount',
  'bankFeedAccount',
  'bankFeedTransaction',
  'benefitPlan',
  'bill',
  'billLine',
  'board',
  'bom',
  'branch',
  'budget',
  'build',
  'businessUnit',
  'calendar',
  'calendarEvent',
  'call',
  'campaign',
  'candidate',
  'cart',
  'case',
  'cashFlowStatementReport',
  'cashSale',
  'catalog',
  'category',
  'changeOrder',
  'changeRequest',
  'channel',
  'charge',
  'checklist',
  'checkout',
  'collection',
  'column',
  'comment',
  'commit',
  'company',
  'compensation',
  'connection',
  'connector',
  'contact',
  'contactMethod',
  'contract',
  'contractAmendment',
  'conversation',
  'costCenter',
  'coupon',
  'creativeAsset',
  'creditMemo',
  'creditNote',
  'crmAccount',
  'customer',
  'customField',
  'customObject',
  'dashboard',
  'database',
  'dataset',
  'dataSource',
  'dataSync',
  'deal',
  'debitNote',
  'demandPlan',
  'department',
  'dependency',
  'dependent',
  'deployment',
  'deposit',
  'device',
  'dimension',
  'discount',
  'dispute',
  'division',
  'document',
  'drive',
  'eeocResponse',
  'email',
  'emailCampaign',
  'emailTemplate',
  'employee',
  'employeePayrollRun',
  'employerBenefit',
  'employment',
  'endpoint',
  'engagement',
  'engagementType',
  'environment',
  'epic',
  'escalation',
  'estimate',
  'event',
  'exchangeRate',
  'expense',
  'expenseReport',
  'experiment',
  'exportJob',
  'featureRequest',
  'file',
  'fileVersion',
  'fiscalYear',
  'folder',
  'form',
  'formSubmission',
  'fulfillment',
  'generalLedgerTransaction',
  'goodsReceipt',
  'group',
  'importJob',
  'incident',
  'incomeStatementReport',
  'integration',
  'interview',
  'interviewStage',
  'inventory',
  'inventoryItem',
  'inventoryLevel',
  'inventoryTransfer',
  'invitation',
  'invoice',
  'invoiceLine',
  'issue',
  'item',
  'itemFulfillment',
  'itemReceipt',
  'job',
  'jobApplication',
  'jobPosting',
  'journalEntry',
  'journalLine',
  'journey',
  'keyResult',
  'keyword',
  'knowledgeArticle',
  'label',
  'landingPage',
  'lead',
  'ledgerAccount',
  'legalEntity',
  'list',
  'location',
  'mapping',
  'meeting',
  'membership',
  'mention',
  'mergeRequest',
  'message',
  'metric',
  'milestone',
  'model',
  'monitor',
  'note',
  'notification',
  'objective',
  'offer',
  'office',
  'opportunity',
  'order',
  'orderLine',
  'organization',
  'page',
  'patient',
  'payGroup',
  'payment',
  'paymentIntent',
  'paymentMethod',
  'paymentTerm',
  'payout',
  'payrollRun',
  'permission',
  'phoneNumber',
  'pipeline',
  'policy',
  'portfolio',
  'position',
  'price',
  'priceBook',
  'problem',
  'product',
  'productVariant',
  'program',
  'project',
  'property',
  'proposal',
  'purchaseOrder',
  'purchaseOrderLine',
  'purchaseReceipt',
  'purchaseRequisition',
  'query',
  'queue',
  'quote',
  'quoteLine',
  'reaction',
  'reconciliation',
  'recording',
  'refreshToken',
  'refund',
  'reimbursement',
  'rejectionReason',
  'release',
  'renewal',
  'report',
  'repository',
  'requestForQuote',
  'resourceAllocation',
  'return',
  'returnAuthorization',
  'returnItem',
  'rma',
  'role',
  'runbook',
  'salesOrder',
  'salesOrderLine',
  'salesReceipt',
  'satisfactionResponse',
  'schedule',
  'scorecard',
  'screeningQuestion',
  'secret',
  'segment',
  'service',
  'serviceAccount',
  'serviceRequest',
  'session',
  'settlement',
  'shipment',
  'shipmentItem',
  'signatureRequest',
  'sku',
  'slaPolicy',
  'sprint',
  'stage',
  'status',
  'stockMovement',
  'subscriber',
  'subscription',
  'subscriptionPlan',
  'subsidiary',
  'subtask',
  'supplierContract',
  'supplyPlan',
  'syncState',
  'tag',
  'task',
  'taxCode',
  'taxRate',
  'team',
  'template',
  'thread',
  'ticket',
  'timeOffBalance',
  'timeOffRequest',
  'timesheet',
  'timesheetApproval',
  'timesheetEntry',
  'timezoneSetting',
  'touchpoint',
  'trackingCategory',
  'transaction',
  'transferOrder',
  'trigger',
  'unknownObject',
  'user',
  'userProfile',
  'vendor',
  'vendorBill',
  'vendorCatalog',
  'vendorCredit',
  'view',
  'viewerAssignment',
  'vulnerability',
  'warehouse',
  'webhookEndpoint',
  'webhookEvent',
  'workflow',
  'workflowRun',
  'workOrder',
  'workspace',
  'workTicket'
];

export const recordTypes = Object.freeze(
  recordTypeKeys.reduce((acc, key) => {
    acc[key] = buildRecordTypeLabel(key);
    return acc;
  }, {})
);

// Explicit plural labels for every record type. UI copy and the workflow
// website metadata pipeline read these, so keep them human-reviewed literals
// (irregulars like Categories, Statuses, and SKUs cannot be derived safely).
export const recordTypePlurals = Object.freeze({
  accessReview: 'Access Reviews',
  accessToken: 'Access Tokens',
  account: 'Accounts',
  accountingPeriod: 'Accounting Periods',
  action: 'Actions',
  activity: 'Activities',
  ad: 'Ads',
  adCampaign: 'Ad Campaigns',
  address: 'Addresses',
  adGroup: 'Ad Groups',
  alert: 'Alerts',
  announcement: 'Announcements',
  apiKey: 'API Keys',
  application: 'Applications',
  appointment: 'Appointments',
  approval: 'Approvals',
  asset: 'Assets',
  attachment: 'Attachments',
  attendanceRecord: 'Attendance Records',
  attendee: 'Attendees',
  attributionEvent: 'Attribution Events',
  audience: 'Audiences',
  auditLog: 'Audit Logs',
  backlogItem: 'Backlog Items',
  balanceSheetReport: 'Balance Sheet Reports',
  bankAccount: 'Bank Accounts',
  bankFeedAccount: 'Bank Feed Accounts',
  bankFeedTransaction: 'Bank Feed Transactions',
  benefitPlan: 'Benefit Plans',
  bill: 'Bills',
  billLine: 'Bill Lines',
  board: 'Boards',
  bom: 'BOMs',
  branch: 'Branches',
  budget: 'Budgets',
  build: 'Builds',
  businessUnit: 'Business Units',
  calendar: 'Calendars',
  calendarEvent: 'Calendar Events',
  call: 'Calls',
  campaign: 'Campaigns',
  candidate: 'Candidates',
  cart: 'Carts',
  case: 'Cases',
  cashFlowStatementReport: 'Cash Flow Statement Reports',
  cashSale: 'Cash Sales',
  catalog: 'Catalogs',
  category: 'Categories',
  changeOrder: 'Change Orders',
  changeRequest: 'Change Requests',
  channel: 'Channels',
  charge: 'Charges',
  checklist: 'Checklists',
  checkout: 'Checkouts',
  collection: 'Collections',
  column: 'Columns',
  comment: 'Comments',
  commit: 'Commits',
  company: 'Companies',
  compensation: 'Compensations',
  connection: 'Connections',
  connector: 'Connectors',
  contact: 'Contacts',
  contactMethod: 'Contact Methods',
  contract: 'Contracts',
  contractAmendment: 'Contract Amendments',
  conversation: 'Conversations',
  costCenter: 'Cost Centers',
  coupon: 'Coupons',
  creativeAsset: 'Creative Assets',
  creditMemo: 'Credit Memos',
  creditNote: 'Credit Notes',
  crmAccount: 'CRM Accounts',
  customer: 'Customers',
  customField: 'Custom Fields',
  customObject: 'Custom Objects',
  dashboard: 'Dashboards',
  database: 'Databases',
  dataset: 'Datasets',
  dataSource: 'Data Sources',
  dataSync: 'Data Syncs',
  deal: 'Deals',
  debitNote: 'Debit Notes',
  demandPlan: 'Demand Plans',
  department: 'Departments',
  dependency: 'Dependencies',
  dependent: 'Dependents',
  deployment: 'Deployments',
  deposit: 'Deposits',
  device: 'Devices',
  dimension: 'Dimensions',
  discount: 'Discounts',
  dispute: 'Disputes',
  division: 'Divisions',
  document: 'Documents',
  drive: 'Drives',
  eeocResponse: 'EEOC Responses',
  email: 'Emails',
  emailCampaign: 'Email Campaigns',
  emailTemplate: 'Email Templates',
  employee: 'Employees',
  employeePayrollRun: 'Employee Payroll Runs',
  employerBenefit: 'Employer Benefits',
  employment: 'Employments',
  endpoint: 'Endpoints',
  engagement: 'Engagements',
  engagementType: 'Engagement Types',
  environment: 'Environments',
  epic: 'Epics',
  escalation: 'Escalations',
  estimate: 'Estimates',
  event: 'Events',
  exchangeRate: 'Exchange Rates',
  expense: 'Expenses',
  expenseReport: 'Expense Reports',
  experiment: 'Experiments',
  exportJob: 'Export Jobs',
  featureRequest: 'Feature Requests',
  file: 'Files',
  fileVersion: 'File Versions',
  fiscalYear: 'Fiscal Years',
  folder: 'Folders',
  form: 'Forms',
  formSubmission: 'Form Submissions',
  fulfillment: 'Fulfillments',
  generalLedgerTransaction: 'General Ledger Transactions',
  goodsReceipt: 'Goods Receipts',
  group: 'Groups',
  importJob: 'Import Jobs',
  incident: 'Incidents',
  incomeStatementReport: 'Income Statement Reports',
  integration: 'Integrations',
  interview: 'Interviews',
  interviewStage: 'Interview Stages',
  inventory: 'Inventory',
  inventoryItem: 'Inventory Items',
  inventoryLevel: 'Inventory Levels',
  inventoryTransfer: 'Inventory Transfers',
  invitation: 'Invitations',
  invoice: 'Invoices',
  invoiceLine: 'Invoice Lines',
  issue: 'Issues',
  item: 'Items',
  itemFulfillment: 'Item Fulfillments',
  itemReceipt: 'Item Receipts',
  job: 'Jobs',
  jobApplication: 'Job Applications',
  jobPosting: 'Job Postings',
  journalEntry: 'Journal Entries',
  journalLine: 'Journal Lines',
  journey: 'Journeys',
  keyResult: 'Key Results',
  keyword: 'Keywords',
  knowledgeArticle: 'Knowledge Articles',
  label: 'Labels',
  landingPage: 'Landing Pages',
  lead: 'Leads',
  ledgerAccount: 'Ledger Accounts',
  legalEntity: 'Legal Entities',
  list: 'Lists',
  location: 'Locations',
  mapping: 'Mappings',
  meeting: 'Meetings',
  membership: 'Memberships',
  mention: 'Mentions',
  mergeRequest: 'Merge Requests',
  message: 'Messages',
  metric: 'Metrics',
  milestone: 'Milestones',
  model: 'Models',
  monitor: 'Monitors',
  note: 'Notes',
  notification: 'Notifications',
  objective: 'Objectives',
  offer: 'Offers',
  office: 'Offices',
  opportunity: 'Opportunities',
  order: 'Orders',
  orderLine: 'Order Lines',
  organization: 'Organizations',
  page: 'Pages',
  patient: 'Patients',
  payGroup: 'Pay Groups',
  payment: 'Payments',
  paymentIntent: 'Payment Intents',
  paymentMethod: 'Payment Methods',
  paymentTerm: 'Payment Terms',
  payout: 'Payouts',
  payrollRun: 'Payroll Runs',
  permission: 'Permissions',
  phoneNumber: 'Phone Numbers',
  pipeline: 'Pipelines',
  policy: 'Policies',
  portfolio: 'Portfolios',
  position: 'Positions',
  price: 'Prices',
  priceBook: 'Price Books',
  problem: 'Problems',
  product: 'Products',
  productVariant: 'Product Variants',
  program: 'Programs',
  project: 'Projects',
  property: 'Properties',
  proposal: 'Proposals',
  purchaseOrder: 'Purchase Orders',
  purchaseOrderLine: 'Purchase Order Lines',
  purchaseReceipt: 'Purchase Receipts',
  purchaseRequisition: 'Purchase Requisitions',
  query: 'Queries',
  queue: 'Queues',
  quote: 'Quotes',
  quoteLine: 'Quote Lines',
  reaction: 'Reactions',
  reconciliation: 'Reconciliations',
  recording: 'Recordings',
  refreshToken: 'Refresh Tokens',
  refund: 'Refunds',
  reimbursement: 'Reimbursements',
  rejectionReason: 'Rejection Reasons',
  release: 'Releases',
  renewal: 'Renewals',
  report: 'Reports',
  repository: 'Repositories',
  requestForQuote: 'Request For Quotes',
  resourceAllocation: 'Resource Allocations',
  return: 'Returns',
  returnAuthorization: 'Return Authorizations',
  returnItem: 'Return Items',
  rma: 'RMAs',
  role: 'Roles',
  runbook: 'Runbooks',
  salesOrder: 'Sales Orders',
  salesOrderLine: 'Sales Order Lines',
  salesReceipt: 'Sales Receipts',
  satisfactionResponse: 'Satisfaction Responses',
  schedule: 'Schedules',
  scorecard: 'Scorecards',
  screeningQuestion: 'Screening Questions',
  secret: 'Secrets',
  segment: 'Segments',
  service: 'Services',
  serviceAccount: 'Service Accounts',
  serviceRequest: 'Service Requests',
  session: 'Sessions',
  settlement: 'Settlements',
  shipment: 'Shipments',
  shipmentItem: 'Shipment Items',
  signatureRequest: 'Signature Requests',
  sku: 'SKUs',
  slaPolicy: 'SLA Policies',
  sprint: 'Sprints',
  stage: 'Stages',
  status: 'Statuses',
  stockMovement: 'Stock Movements',
  subscriber: 'Subscribers',
  subscription: 'Subscriptions',
  subscriptionPlan: 'Subscription Plans',
  subsidiary: 'Subsidiaries',
  subtask: 'Subtasks',
  supplierContract: 'Supplier Contracts',
  supplyPlan: 'Supply Plans',
  syncState: 'Sync States',
  tag: 'Tags',
  task: 'Tasks',
  taxCode: 'Tax Codes',
  taxRate: 'Tax Rates',
  team: 'Teams',
  template: 'Templates',
  thread: 'Threads',
  ticket: 'Tickets',
  timeOffBalance: 'Time Off Balances',
  timeOffRequest: 'Time Off Requests',
  timesheet: 'Timesheets',
  timesheetApproval: 'Timesheet Approvals',
  timesheetEntry: 'Timesheet Entries',
  timezoneSetting: 'Timezone Settings',
  touchpoint: 'Touchpoints',
  trackingCategory: 'Tracking Categories',
  transaction: 'Transactions',
  transferOrder: 'Transfer Orders',
  trigger: 'Triggers',
  unknownObject: 'Unknown Objects',
  user: 'Users',
  userProfile: 'User Profiles',
  vendor: 'Vendors',
  vendorBill: 'Vendor Bills',
  vendorCatalog: 'Vendor Catalogs',
  vendorCredit: 'Vendor Credits',
  view: 'Views',
  viewerAssignment: 'Viewer Assignments',
  vulnerability: 'Vulnerabilities',
  warehouse: 'Warehouses',
  webhookEndpoint: 'Webhook Endpoints',
  webhookEvent: 'Webhook Events',
  workflow: 'Workflows',
  workflowRun: 'Workflow Runs',
  workOrder: 'Work Orders',
  workspace: 'Workspaces',
  workTicket: 'Work Tickets'
});

export const getRecordTypePluralLabel = (recordTypeKey) => {
  return recordTypePlurals[recordTypeKey] || null;
};

export const recordTypeOptions = recordTypeKeys.map((value) => ({
  value,
  label: recordTypes[value]
}));

export const isLegacyRecordTypeKey = (value) => {
  return typeof value === 'string' && value.includes('.');
};
